module.exports = __webpack_public_path__ + "img/icon_enterpriserealty_overview_05.f6fc0534.svg";